export enum FieldTypeEnum {
  None,
  Input,
  Dropdown,
  Attachment,
  Page,
}

export enum PriceEnum {
  None,
  Percentage,
  Total,
}

export enum FieldInputTypeEnum {
  None,
  Number,
  Any,
  Date,
}

export enum FormStatusEnum {
  Draft,
  Publish,
}

export enum ConditionMethodEnum {
  And,
  Or,
}
